const estensioni_accettate = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];

export const getEstensioni = () => {
  return estensioni_accettate;
};
